export default __webpack_public_path__ + "static/media/5.7af6d9cd.png";